import { DocumentNode } from 'graphql/index';
import { CreateResponsibilitiesMutationResult } from '../responsibilities';
import { UpdateFunctionalAreasMutationResult } from '../functionalArea';
import { gql } from '@apollo/client/core';
import { MyApp } from '../../../types/myAppTypes';

/**
 * GraphQL mutation for updating applications.
 */
export const UpdateApplicationsQuery = gql`
  mutation UpdateApplications($input: [UpdateApplicationInput!]!) {
    resources {
      application {
        updateApplications(input: $input) {
          applicationId
          success
          message
        }
      }
    }
  }
`;

export type UpdateApplicationMutationResult = {
  resources: {
    application: {
      updateApplications: MutationStatus[];
    };
  };
};

export type MutationStatus = {
  applicationId: number;
  success: boolean;
  message: string;
};

export type BaseMutationResult =
  | UpdateApplicationMutationResult
  | CreateResponsibilitiesMutationResult
  | UpdateFunctionalAreasMutationResult;

export interface BaseApplicationProperty {
  field: string;
  value?: any;
  label: string;
  propertyMutationInput(): any;
  set(value: any): void;
  getNewDisplayValue(): string;
  mutationQuery(): DocumentNode;
  getMutationResult(data: BaseMutationResult): MutationStatus[];
  getCurrentDisplayValue?(app: MyApp): string;
}
